
import React from "react";

interface VideoPlayerProps {
  videoURL: string;
}


// EVENT REFERENCE (for analytics (e.g. play, pause, etc.), etc.) - 
// -- https://developer.vimeo.com/player/sdk/reference#events-for-playback-controls

function VideoPlayer({ videoURL }: VideoPlayerProps) {

  // TODO: Proper "default video" (??) - Still need make sure all this is secure & not stealable / hackable
  const videoSource = videoURL ? videoURL : "https://player.vimeo.com/video/907656950";

  return (
    <>
      <div style={{ padding: "56.25% 0 0 0", position: "relative" }}>
        <iframe
          src={`${videoSource}?badge=0&autopause=0&player_id=0&app_id=58479`}
          frameBorder="0"
          allow="autoplay; fullscreen;"
          style={{ position: "absolute", top: "0", left: "0", width: "100%", height: "100%" }}
          title="Test Video Name"
        ></iframe>
      </div>
      <script src="https://player.vimeo.com/api/player.js"></script>

      {/*
      <script>
        const iframe = document.querySelector( "iframe" );
        const player = new Vimeo.Player( iframe );

        player.on( "play", () => {
          console.log( "PLAYING..." );
        });
      </script>
      */}
    </>
  );
}

export default VideoPlayer;
